// contact-page.constants.ts

import type {
  BriefingExpectation,
  ContactDomainOption,
  ContactFormModel,
} from '../models/contact-page.model';

export const BRIEFING_EXPECTATIONS: ReadonlyArray<BriefingExpectation> = [
  {
    id: 'owned-protected-ip',
    titleKey: 'contact.expectations.items.ownedProtectedIP.title',
    descriptionKey: 'contact.expectations.items.ownedProtectedIP.description',
    tone: 'navy',
  },
  {
    id: 'sovereign-grade-security',
    titleKey: 'contact.expectations.items.sovereignGradeSecurity.title',
    descriptionKey: 'contact.expectations.items.sovereignGradeSecurity.description',
    tone: 'gradient',
  },
  {
    id: 'traceable-reasoning',
    titleKey: 'contact.expectations.items.traceableReasoning.title',
    descriptionKey: 'contact.expectations.items.traceableReasoning.description',
    tone: 'navy',
  },
] as const;

export const CONTACT_AVAILABLE_DOMAINS: ReadonlyArray<ContactDomainOption> = [
  {
    id: 'maritime',
    labelKey: 'contactUsPage.domains.maritime',
  },
  {
    id: 'defense',
    labelKey: 'contactUsPage.domains.defense',
  },
  {
    id: 'countryInvestment',
    labelKey: 'contactUsPage.domains.countryInvestment',
  },
  {
    id: 'financial',
    labelKey: 'contactUsPage.domains.financial',
  },
  {
    id: 'sectoral',
    labelKey: 'contactUsPage.domains.sectoral',
  },
  {
    id: 'foreignAffairs',
    labelKey: 'contactUsPage.domains.foreignAffairs',
  },
  {
    id: 'countryStrategy',
    labelKey: 'contactUsPage.domains.countryStrategy',
  },
  {
    id: 'enterpriseStrategy',
    labelKey: 'contactUsPage.domains.enterpriseStrategy',
  },
] as const;

export const CONTACT_INITIAL_MODEL: ContactFormModel = {
  name: '',
  email: '',
  phone: '',
  company_name: '',
  subject: '',
  organization_type: '',
  // domains: [],
  time_frame: '',
  message: '',
};
